module.exports = __webpack_public_path__ + "static/media/trash.f36a1ffd.svg";